import { render, staticRenderFns } from "./CentralPage.vue?vue&type=template&id=7be37c8e&"
import script from "./CentralPage.vue?vue&type=script&lang=js&"
export * from "./CentralPage.vue?vue&type=script&lang=js&"
import style0 from "./CentralPage.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSheet } from 'vuetify/lib/components/VSheet';
installComponents(component, {VContainer,VRow,VSheet})
